import { Container } from 'src/components/Container/Container'
import { BRAND_VALUES } from 'src/selectors'

import { BrandValueCard } from './BrandValueCard'
import styles from './BrandValues.module.scss'

import type { SanityBrandValueItem } from 'src/types/HomepageContent'

interface SanityBrandValuesProps {
  items: SanityBrandValueItem[]
}

export const BrandValues = ({ items }: SanityBrandValuesProps) => (
  <div className={styles.brand} data-cy={BRAND_VALUES}>
    <Container className={styles.container}>
      {items.map((item) => item.text && <BrandValueCard key={item.title} title={item.title} text={item.text} />)}
    </Container>
  </div>
)
